<template>
  <div>
    <div class="addClaimExpense">
      <div class="newsDetial-header">
        <!-- 新增title -->
        <template v-if="!id">
          <div class="newsDetial-title">基本信息添加</div>
          <blank height="7"> </blank>
          <div class="newsDetial-abstract" style="padding-bottom: 20px">
            请按照文本要求添加表单，并提交进行流程审批
          </div>
        </template>
        <!-- 查看修改 -->
        <template v-else>
          <div v-if="tabnum == 1">
            <div class="newsDetial-title">车辆信息管理</div>
            <blank height="7"> </blank>
            <div class="card-title">
              <div class="state1" v-if="resData.state == 1">审批中</div>
              <div class="state2" v-if="resData.state == 2">已归档</div>
              <div class="state3" v-if="resData.state == 3">退回</div>
              <div class="state4" v-if="resData.state == 4">取消</div>
            </div>
          </div>
          <div v-else>
            <div class="newsDetial-title">车辆信息管理审批流程</div>
            <blank height="7"> </blank>
            <a-button
              class="detial-top-btn"
              type="primary"
              icon="printer"
              v-if="resData.state == 2"
              @click="printDDD()"
            >
              打印
            </a-button>
          </div>
          <a-tabs v-model="tabnum" @change="tabClick">
            <a-tab-pane key="1" tab="表单详情" />
            <a-tab-pane
              key="2"
              tab="表单流程"
              v-if="resData.state > 0 && version == ''"
            />
          </a-tabs>
        </template>
      </div>
      <!-- 基本信息 -->
      <div class="detial-cont" v-if="tabnum == 1">
        <div class="detial-cont-title">表单基本信息</div>
        <blank height="1"> </blank>
        <form-base-info
          :disabled="disabled"
          v-model="resData"
          :resData="resData"
        ></form-base-info>
      </div>
      <!-- 审批流 -->
      <div class="detial-cont" v-if="tabnum == 2">
        <div class="detial-cont-title">审批流程图示</div>
        <blank height="1"> </blank>
        <div class="detial-cont-view">
          <!-- 审批流 表单流程 -->
          <keep-alive>
            <approvalChart
              ref="refChart"
              :approvalChartData="approvalChartData"
            ></approvalChart>
          </keep-alive>
        </div>
      </div>
      <!-- 底部按钮 -->
      <appfloor v-if="tabnum == 2"></appfloor>
      <template v-if="tabnum == 1">
        <bottomSuspension>
          <a-button :style="{ marginRight: '20px' }" @click="goback">
            返回
          </a-button>
          <!-- 表单为可编辑状态 显示提交按钮 -->
          <template>
            <div v-if="proQueryParams.isEdit === '0' ? true : false">
              <a-button
                :loading="confirmLoading && resData.draft == 2"
                type="primary"
                class="orange-btn"
                @click="preserveFn('0')"
                :style="{ marginRight: '20px' }"
              >
                保存
              </a-button>
            </div>
            <a-button
              v-if="!resData.state && !disabled"
              :loading="confirmLoading && resData.draft == 1"
              type="primary"
              class="orange-btn"
              @click="preserveFn('1')"
              :style="{ marginRight: '20px' }"
            >
              保存
            </a-button>
            <a-button
              v-if="!resData.state && !disabled"
              :loading="loading && resData.draft == 2"
              type="primary"
              :style="{ marginRight: '20px' }"
              @click="submitFn"
            >
              提交
            </a-button>
            <a-button
              v-if="proQueryParams.showApproveBtn === '1'"
              :loading="loading && resData.draft == 2"
              type="primary"
              :style="{ marginRight: '20px' }"
              @click="submitFn"
            >
              {{ resData.state === 3 ? '提交' : '审批' }}
            </a-button>
          </template>
          <!-- 表单正在审批状态  显示审批按钮 -->
          <div v-if="proQueryParams.showApproveBtn === '1' ? true : false">
            <a-button
              v-if="resData.state === 3 ? true : false"
              type="danger"
              @click="cancelPro('2')"
              :style="{ marginRight: '20px' }"
            >
              删除
            </a-button>
            <!-- <a-button
              v-if="resData.state === 3 ? true : false"
              type="primary"
              @click="cancelPro('1')"
              :style="{ marginRight: '20px' }"
            >
              提交
            </a-button>
            <a-button
              v-if="resData.state === 3 ? false : true"
              @click="approvalPro"
              type="primary"
              :style="{ marginRight: '42px' }"
            >
              审批
            </a-button> -->
          </div>
        </bottomSuspension>
      </template>
    </div>
    <!-- 审批流审批弹窗 -->
    <approvalSubmission v-model="isActivitiMode"></approvalSubmission>
    <print
      v-model="isPrint"
      v-if="resData.state == 2"
      :id="id"
      mobilePath="/pages/workbench/vehicleInfo/details?id="
      skipPageReqFlag="/vehicleInfoDetails"
    >
      <div class="print-title">北京民政工业总公司车辆信息管理审批表单</div>
      <div class="printd-cont">
        <div class="printd-item">
          <a-descriptions bordered size="small">
            <a-descriptions-item label="产权单位名称" :span="3">
              {{ resData.propertyRightName }}
            </a-descriptions-item>
            <a-descriptions-item label="使用单位" :span="3">
              {{ resData.useunit }}
            </a-descriptions-item>
            <a-descriptions-item label="责任人" :span="1.5">
              {{ resData.responsiblepeople }}
            </a-descriptions-item>
            <a-descriptions-item label="责任电话" :span="1.5">
              {{ resData.phone }}
            </a-descriptions-item>
            <a-descriptions-item label="车牌号" :span="1.5">
              {{ resData.carnumber }}
            </a-descriptions-item>
            <a-descriptions-item label="发动机号" :span="1.5">
              {{ resData.engineno }}
            </a-descriptions-item>
            <a-descriptions-item label="年检时间" :span="1.5">
              {{ resData.duringtime }}
            </a-descriptions-item>
            <a-descriptions-item label="下次年检时间" :span="1.5">
              {{ resData.nextduringtime }}
            </a-descriptions-item>
            <a-descriptions-item label="是否报废" :span="1.5">
              {{ getByTypeName(resData.scrap, bytype.whetherList) }}
            </a-descriptions-item>
            <a-descriptions-item label="标识号" :span="1.5">
              {{ resData.logo }}
            </a-descriptions-item>
            <a-descriptions-item label="标识种类" :span="1.5">
              {{ resData.logotitle }}
            </a-descriptions-item>
            <a-descriptions-item label="车辆类型" :span="1.5">
              {{
                getByTypeName(
                  resData.carApplicationType,
                  bytype.carApplicationTypeList
                )
              }}
            </a-descriptions-item>
            <a-descriptions-item label="备注" :span="3">
              {{ resData.title }}
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="printd-item">
          <a-table
            size="small"
            :pagination="false"
            :columns="columns"
            :data-source="formDTOList"
            :row-key="(record) => record.id"
            bordered
          >
          </a-table>
        </div>
      </div>
    </print>
  </div>
</template>
<script>
import formBaseInfo from './components/formBaseInfo.vue'
import {
  vehiclelistDetails,
  saveVehiclel,
  updateVehiclel,
  getHistoryDetial
} from './api'
import approvalSubmission from '@/components/approval-submission/index'
import approvalChart from '@/components/approval-chart/index'
import { activitiSubmission } from '@/utils/utils'
import { mapState } from 'vuex'
export default {
  components: { formBaseInfo, approvalSubmission, approvalChart },
  data() {
    return {
      tabnum: '1',
      resData: {},
      id: '',
      version: '',
      confirmLoading: false,
      loading: false,
      // 审批流部分
      // disabled: true,
      isActivitiMode: {
        isActivitiShow: false,
        proQueryParams: []
      },
      proQueryParams: [],
      // 审批流部分
      // 打印部分
      isPrint: false, // 打印弹窗
      columns: [
        {
          title: '审批部门（人）',
          dataIndex: 'dutyOfficerStr',
          key: 'dutyOfficerStr',
          align: 'left'
        },
        {
          title: '审批意见',
          dataIndex: 'fieldValue1',
          key: 'fieldValue1',
          align: 'left'
        },
        {
          title: '审批时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'left'
        }
      ],
      formDTOList: [],
      pIsedit: ''
    }
  },

  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.version = this.$route.query.version ? this.$route.query.version : ''
      if (this.version) {
        this.getHistoryDetialFn()
      } else {
        this.vehiclelistDetailsFn()
      }
    }
  },
  watch: {
    resData: {
      handler(val) {
        // console.log(val)
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['bytype']),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function () {
      if (!this.id) {
        // id不存在  为添加  可编辑
        return false
      } else {
        this.proQueryParams = this.$route.query
        if (this.proQueryParams.isEdit) {
          if (
            this.proQueryParams.isEdit === '100' ||
            this.proQueryParams.isEdit === '1'
          ) {
            return true
          } else {
            return false
          }
        } else if (this.resData.state == 1 || this.resData.state == 2) {
          //审批状态和归档状态  不可编辑
          return true
        } else {
          // 草稿箱或退回状态  可编辑
          return false
        }
      }
    }
  },
  methods: {
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    printDDD() {
      this.formDTOList = this.$refs.refChart.getHighLine.formDTOList
      this.isPrint = true
      document.title =
        '车辆信息管理-' +
        this.resData.responsiblepeople +
        this.$printFormatDate(new Date())
    },
    // 详情
    vehiclelistDetailsFn() {
      const params = {
        id: this.id
      }
      vehiclelistDetails(params).then((res) => {
        if (res.data.code == 0) {
          this.resData = res.data.data
          // 多个对象合并合并多个
          let processInstanceId = {
            processInstanceId: res.data.data.processInstanceId,
            detailsData: res.data.data
          }
          Object.assign(this.proQueryParams, processInstanceId)
        }
      })
    },
    //历史详情
    getHistoryDetialFn() {
      getHistoryDetial({ id: this.id, version: this.version }).then((res) => {
        if (res.data.code == 0) {
          this.resData = res.data.data
        }
      })
    },
    saveFormFn(type) {
      let params = Object.assign({}, this.resData)
      params.appId = this.$route.meta.appId
      params.skipPageReqFlag = '/vehicleInfoDetails'
      if (this.pIsedit === '') {
        this.loading = true
      } else {
        this.confirmLoading = true
      }
      if (this.id) {
        updateVehiclel(params).then((res) => {
          if (res.data.code == 0) {
            if (this.pIsedit === '1') {
              this.$message.success('保存成功')
              this.pIsedit = ''
            } else {
              if (params.state > 0) {
                this.vehiclelistDetailsFn()
                // 合并 保存+审批流操作
                if (
                  this.proQueryParams.showApproveBtn === '1' &&
                  params.state != '3'
                ) {
                  this.approvalPro()
                } else {
                  this.cancelPro('1')
                }
                // this.$message.success('修改成功')
                // 合并 保存+审批流操作
              } else {
                if (params.draft == 2) {
                  this.$message.success('提交成功')
                  this.goback()
                } else {
                  this.$message.success('保存成功')
                }
              }
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      } else {
        saveVehiclel(params).then((res) => {
          if (res.data.code == 0) {
            this.$message.success(type + '成功')
            if (params.draft == 2) {
              this.goback()
            } else {
              //首次添加
              this.id = res.data.data
              this.vehiclelistDetailsFn()
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      }
    },
    // 审批流取消
    cancelPro(key) {
      switch (key) {
        case '1':
          // 提交
          this.$confirm({
            title: '您是否提交?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '1', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break
        case '2':
          // 取消
          this.$confirm({
            title: '您是否删除?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '2', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break

        default:
          break
      }
    },
    // 切换审批流 表单流程
    tabClick(key) {
      if (key == 2) {
        this.approvalChartData = this.proQueryParams
      } else {
        this.vehiclelistDetailsFn()
      }
    },
    //  工作流审批
    approvalPro() {
      this.isActivitiMode = {
        isActivitiShow: true,
        proQueryParams: this.proQueryParams
      }
    },
    // 返回
    goback() {
      this.$router.push('/vehicleInfo')
    },
    // 保存
    preserveFn(type) {
      if (type === '0') {
        // 自定义保存判断 1 = 仅保存
        this.pIsedit = '1'
        this.resData.draft = 2
      } else {
        this.pIsedit = '2'
        this.resData.draft = 1
      }
      if (!this.resData.propertyRightName) {
        this.$message.error('请输入产权单位名称')
        return false
      }
      if (!this.resData.useunit) {
        this.$message.error('请输入使用单位')
        return false
      }
      if (!this.resData.responsiblepeople) {
        this.$message.error('请输入责任人')
        return false
      }
      if (!this.resData.phone) {
        this.$message.error('请输入责任人电话')
        return false
      }
      if (!this.filterPhone(this.resData.phone)) {
        this.$message.error('请输入正确格式的责任人电话')
        return false
      }
      if (!this.resData.carnumber) {
        this.$message.error('请输入车牌号')
        return false
      }
      if (!this.resData.engineno) {
        this.$message.error('请输入发动机号')
        return false
      }
      if (!this.resData.duringtime) {
        this.$message.error('请选择年检时间')
        return false
      }
      if (!this.resData.nextduringtime) {
        this.$message.error('请选择下次年检时间')
        return false
      }
      if (!this.resData.scrap || this.resData.scrap.length == 0) {
        this.$message.error('请选择是否报废')
        return false
      }
      this.confirmLoading = true
      this.saveFormFn('保存')
    },
    // 提交
    submitFn() {
      if (!this.resData.propertyRightName) {
        this.$message.error('请输入产权单位名称')
        return false
      }
      if (!this.resData.useunit) {
        this.$message.error('请输入使用单位')
        return false
      }
      if (!this.resData.responsiblepeople) {
        this.$message.error('请输入责任人')
        return false
      }
      if (!this.resData.phone) {
        this.$message.error('请输入责任人电话')
        return false
      }
      if (!this.filterPhone(this.resData.phone)) {
        this.$message.error('请输入正确格式的责任人电话')
        return false
      }
      if (!this.resData.carnumber) {
        this.$message.error('请输入车牌号')
        return false
      }
      if (!this.resData.engineno) {
        this.$message.error('请输入发动机号')
        return false
      }
      if (!this.resData.duringtime) {
        this.$message.error('请选择年检时间')
        return false
      }
      if (!this.resData.nextduringtime) {
        this.$message.error('请选择下次年检时间')
        return false
      }
      if (!this.resData.scrap || this.resData.scrap.length == 0) {
        this.$message.error('请选择是否报废')
        return false
      }
      this.resData.draft = 2
      this.saveFormFn('添加')
    }
  }
}
</script>

<style lang="scss" scoped>
.addClaimExpense {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .detial-bottom {
    height: 56px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
// 打印内容不能嵌套写样式
.print-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
}
</style>

<style scoped src="@/assets/css/printModal.css"></style>



// WEBPACK FOOTER //
// src/views/baseInfoManagement/vehicleInfo/details.vue